import { render, staticRenderFns } from "./EditorBar.vue?vue&type=template&id=1ee5ec96&scoped=true&"
import script from "./EditorBar.vue?vue&type=script&lang=ts&"
export * from "./EditorBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee5ec96",
  null
  
)

export default component.exports